import type { AssetTypeTemplateFormEditorProps } from "./asset-type-template-form-editor.type";

import { Layout, Typography } from "antd";
import { useTranslation } from "react-i18next";

import FormEditor from "@/components/FormEngine/Editor";
import { AssetTypeTemplateSaveBar } from "@/modules/asset-type-template/asset-type-template-save-bar";

import { useTemplateSchema } from "./asset-type-template-form-editor.hook";

const { Content } = Layout;

export const AssetTypeTemplateFormEditor = ({
  template,
  loading,
}: AssetTypeTemplateFormEditorProps) => {
  const { t } = useTranslation();

  const { schema, onCancel, onSave, onUpdate, isSaving } =
    useTemplateSchema(template);

  return (
    <>
      <AssetTypeTemplateSaveBar
        template={template}
        loading={loading || isSaving}
        onSave={onSave}
        onCancel={onCancel}
      />
      <Content>
        <FormEditor
          loading={loading}
          schema={schema || {}}
          context="technical_form"
          onUpdateSchema={onUpdate}
          emptyDescription={
            <Typography.Text>{t("technicalForm:emptyForm")}</Typography.Text>
          }
          parentId={template?.id}
        />
      </Content>
    </>
  );
};
